const RIG_SERVICES = {
  COMPUTE: 'compute',
  STORAGE: 'storage',
};

export default RIG_SERVICES;
